import { Row, Col, Container } from "react-bootstrap";
import { Request } from '@group-devs/yfp7-global-modules';
import { useState, useEffect } from 'react';

const request = new Request(process.env.apiDomain);

export default function ActivitySummary({ props }) {
    const [contactId, setContactId] = useState(null);

    const authContactId = props.auth.site_user ? props.auth.contactId : null;
    const { data: contactAccount } = request.contacts.swrAccount(authContactId);

    useEffect(() => {
        if (contactAccount?.contact_id) {
            setContactId(parseInt(contactAccount.contact_id));
        }
    }, [contactAccount]);

    const { data: articles, isLoading: isLoadingArticles } = request.stats.articlesRead(contactId || '');
    const { data: videos, isLoading: isLoadingVideos } = request.stats.videoWatch(contactId || '');
    const { data: reviews, isLoading: isLoadingReviews } = request.stats.reviewsGiven(contactId || '');
    const { data: recipes, isLoading: isLoadingRecipes } = request.stats.recipeUsed(contactId || '');
    const { data: files, isLoading: isLoadingFiles } = request.stats.filesDownloaded(contactId || '');
    const { data: audios, isLoading: isLoadingAudios } = request.stats.audioListened(contactId || '');

    const summary = [
        {
            name: "Articles Read",
            icons: "img-small-articles-read-01.svg",
            num: isLoadingArticles ? '...' : (articles?.points || 0),
        },
        {
            name: "Videos watched",
            icons: "img-small-videos-watched-01.svg",
            num: isLoadingVideos ? '...' : (videos?.points || 0),
        },
        {
            name: "Recipes used",
            icons: "img-small-recipes-used-01.svg",
            num: isLoadingRecipes ? '...' : (recipes?.points || 0),
        },
        {
            name: "Files downloaded",
            icons: "img-small-files-downloaded-01.svg",
            num: isLoadingFiles ? '...' : (files?.points || 0),
        },
        // Optionally include these later:
        // {
        //     name: "Reviews Given",
        //     icons: "img-small-reviews-given-01.svg",
        //     num: isLoadingReviews ? '...' : (reviews?.points || 0),
        // },
        // {
        //     name: "Audios listened to",
        //     icons: "img-small-audios-listened-to-01.svg",
        //     num: isLoadingAudios ? '...' : (audios?.points || 0),
        // },
    ];

    return (
        <div className="activity-summary">
            <Container>
                <h4 className="font-weight-bold mb-4 pb-3">Activity Summary</h4>
                <ul className="list-unstyled">
                    {summary.map((data, idx) => (
                        <li key={idx} className="mb-lg-4 pb-3">
                            <span className="activity-text">
                                <img src={`/images/learnandearn/${data.icons}`} className="mr-4" />
                                {data.name}
                            </span>
                            <strong className="h3 text-center font-weight-bold">
                                {data.num}
                            </strong>
                        </li>
                    ))}
                </ul>
            </Container>
            <hr className="divider mx-auto " />
            <style jsx global>{`
                .activity-summary ul {
                    display: grid !important;
                    align-items: center;
                    grid-template-columns: repeat(auto-fit, minmax(380px, 2fr));
                }
                .divider {
                    max-width: 1439px;
                }
              
                @media (max-width: 575.98px) {
                    .activity-summary ul {
                        display: block !important;
                    }
                }
    
            `}</style>
            <style jsx>{`
                .activity-summary li span {
                    width: 240px;
                    display: inline-block;
                    font-size: 1.1rem;
                }
            `}</style>
        </div>
    );
}
